var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@apollo/client';
import React, { useContext } from 'react';
import useSWRImmutable from 'swr/immutable';
import { REBUY_API_KEY } from 'shop/lib/util/const';
import CardSection from '../ContentSystem/components/CardSection/CardSection';
import transformRebuyToContentSystem from './RebuyUpsell.utils';
import cardSectionConfigs from './__fixtures__/cardSectionUpsellConfigs.json';
import { get } from '../../util/request';
import { track } from '../../util/optimizely';
import { addProduct as addRebuyProduct } from '../../util/rebuyAttribution';
import { useQuickView } from '../QuickView/QuickView.context';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';
import { GET_USER_LOCALE } from '../App.gql';
var checkIfProduct = function (value) {
    return value.__typename === 'Product';
};
export var RebuyUpsell = function (_a) {
    var rebuyData = _a.rebuyData, withQuickView = _a.withQuickView, dataLabel = _a.dataLabel, dataSourceId = _a.dataSourceId;
    var setActiveProductId = useQuickView().setActiveProductId;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    var transformedRebuyData = transformRebuyToContentSystem(rebuyData);
    var cardSectionUpsellConfig = __assign(__assign({}, cardSectionConfigs), transformedRebuyData);
    if (cardSectionUpsellConfig === null || cardSectionUpsellConfig === void 0 ? void 0 : cardSectionUpsellConfig.cards) {
        cardSectionUpsellConfig.cards = cardSectionUpsellConfig.cards.map(function (card) {
            if (checkIfProduct(card)) {
                return __assign(__assign({}, card), { onClick: function (event) {
                        var _a;
                        track('Clicks_on_product_cards_in_upsell_carousel', {}, 
                        // @ts-expect-error
                        { $opt_event_properties: { sourceId: dataSourceId } });
                        if (withQuickView) {
                            event.preventDefault();
                        }
                        if ((_a = card === null || card === void 0 ? void 0 : card.externalSystems) === null || _a === void 0 ? void 0 : _a.shopify) {
                            addRebuyProduct(card.externalSystems.shopify, dataSourceId);
                            if (withQuickView) {
                                setActiveProductId(card.externalSystems.shopify);
                            }
                        }
                    } });
            }
            return card;
        });
    }
    return (React.createElement(CardSection, __assign({}, cardSectionUpsellConfig, { styleQueryMode: styleQueryMode, dataLabel: dataLabel })));
};
var externalGet = function (path) { return get(path, { is3rdParty: true }); };
export var RebuyUpsellWithData = function (_a) {
    var _b, _c, _d;
    var _e = _a.withQuickView, withQuickView = _e === void 0 ? false : _e, dataLabel = _a.dataLabel, cartSubtotal = _a.cartSubtotal, productIds = _a.productIds, limit = _a.limit, dataSourceId = _a.dataSourceId;
    var userLocaleData = useQuery(GET_USER_LOCALE).data;
    var countryCode = (_c = (_b = userLocaleData === null || userLocaleData === void 0 ? void 0 : userLocaleData.user) === null || _b === void 0 ? void 0 : _b.locale) === null || _c === void 0 ? void 0 : _c.country;
    var makeRebuyUrl = function () {
        var base = "https://rebuyengine.com/api/v1/custom/id/".concat(dataSourceId, "?key=").concat(REBUY_API_KEY);
        var url = new URL(base);
        if (countryCode) {
            url.searchParams.set('url', "country_".concat(countryCode.toLowerCase()));
        }
        if (cartSubtotal) {
            url.searchParams.set('cart_subtotal', (parseFloat(cartSubtotal) * 100).toString());
        }
        if (productIds) {
            url.searchParams.set('shopify_product_ids', productIds.join(','));
        }
        if (limit) {
            url.searchParams.set('limit', limit.toString());
        }
        return url.toString();
    };
    var _f = useSWRImmutable(makeRebuyUrl(), externalGet, {
        keepPreviousData: true
    }), rebuyData = _f.data, error = _f.error;
    if (!((_d = rebuyData === null || rebuyData === void 0 ? void 0 : rebuyData.data) === null || _d === void 0 ? void 0 : _d.length) || error)
        return null;
    return (React.createElement(RebuyUpsell, { rebuyData: rebuyData, withQuickView: withQuickView, dataLabel: dataLabel, dataSourceId: dataSourceId }));
};
export default RebuyUpsell;
